import React from 'react';
import './CompanyStorySection.css';

interface StoryStat {
  number: string;
  text: string;
}

interface CompanyStorySectionProps {
  eyebrow?: string;
  title?: string;
  paragraphs: string[];
  stats: StoryStat[];
  className?: string;
}

const CompanyStorySection: React.FC<CompanyStorySectionProps> = ({
  eyebrow,
  title = "Our Story",
  paragraphs,
  stats,
  className = ""
}) => {
  return (
    <section className={`company-story ${className}`}>
      <div className="section-container">
        <div className="story-content">
          <div className="story-text">
            {eyebrow && <div className="eyebrow">{eyebrow}</div>}
            <h2>{title}</h2>
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div className="story-stats">
            {stats.map((stat, index) => (
              <div key={index} className="story-stat">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-text">{stat.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
